import { render, staticRenderFns } from "./EpochList.vue?vue&type=template&id=0c2f1ded&scoped=true&"
import script from "./EpochList.vue?vue&type=script&lang=js&"
export * from "./EpochList.vue?vue&type=script&lang=js&"
import style0 from "./EpochList.vue?vue&type=style&index=0&id=0c2f1ded&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2f1ded",
  null
  
)

export default component.exports